import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment, environmentLoader as environmentLoaderPromise  } from './environments/environment';


// if (environment.production) {
//   enableProdMode();
// }

environmentLoaderPromise.then(env => {
  if (env.production) {
    enableProdMode();
  }
  environment.soa_authorization         = env.soa_authorization;
  environment.lightbox_data_account     = env.lightbox_data_account;
  environment.lightbox_src              = env.lightbox_src;
  environment.lightbox_data_mode        = env.lightbox_data_mode;
  environment.lightbox_data_amount      = env.lightbox_data_amount;

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
});